import React from 'react';
import VisitOrderBoard from './VisitOrderBoard';
import OfflineReceiptModal from './modal/OfflineReceiptModal';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

/** Orden de visitas del día (recibo sin conexión). */
const OfflineVisitOrderList: React.FC<ShowAlerts> = ({ showLoading, hideLoading }) => (
  <VisitOrderBoard showLoading={showLoading} hideLoading={hideLoading} Receipt={OfflineReceiptModal} />
);

export default OfflineVisitOrderList;
